namespace('arctic.views.common');

compass.require('compass.hotel.HotelInfoWidget');
compass.require('compass.hotel.HotelBookingWidget');

arctic.views.common.hotelInfo = function(viewport, data) {
	// starts measuring the time it takes for the view to load
	compass.startLoad('hotelInfoView');

	var MAX_RETRIES = 2;
	var _viewData = data;
	var _viewport = viewport;
	var _hotelId = _viewData.hotelId;
	var _blockedRoomId = _viewData.blockedRoomId;
	var _meetingInfo = _viewData.meetingInfo;
	var _arriveDate = _viewData.arrive;
	var _departDate = _viewData.depart;
	var _occupancy = _viewData.occupancy;
	var _displayHotelStars = true;
	var _hideDistance = false;

	var _hotel;
	var _hotelBookingWidget;
	var _categoryHasOnlyOneHotelAvail;

	var $j = jQuery;
	var d = $j.dom;

	this.run = function(renderComplete) {
		compass.loading.start();
		
		var defaultDates = {};
		if(_arriveDate && _departDate && _arriveDate.length && _departDate.length){
			defaultDates = {
				'arrive':_arriveDate,
				'depart': _departDate
			};
		}
		else{
			// the gallery looks at peak night if no dates are specified, otherwise, they will be specified here.
			// so deafult dates to peak night here
			defaultDates = {
				'arrive': _meetingInfo.peakNight,
				'depart': _meetingInfo.DayAfterPeakNight
			};
		}
		var dataObject = _.extend({ hotel_id : _hotelId }, defaultDates);
		jQuery.ajax({
			url : '/roomsPopup',
			data : dataObject,
			success : function(hotelData) {
				compass.loading.stop();
				if ( hotelData.error_code && hotelData.error_code.length > 0) {
					_viewport.trigger(CompassEvents.Navigate, 'entry');
					return;
				}
				_hotel = hotelData;
				_categoryHasOnlyOneHotelAvail = hotelData.categoryHasOnlyOneHotelAvail;
				_displayHotelStars = hotelData.displayHotelStarsDecimal;
				_hideDistance = hotelData.hideDistance;
				_hideNumberOfRoomsAvailable = hotelData.hideNumberOfRoomsAvailable;
				_defaultPromotions = hotelData.defaultPromotions;
				_drawHotelBookingWidget();
				// trigger the event to let godview know that a view has loaded and return a string that can be prepended to the header widget
				// for better screen reading of the page
				_viewport.trigger(CompassEvents.ViewLoaded, 'Hotel Information and Room/Date Selection');
				// stops measuring the time it takes the view to load
				compass.stopLoad('hotelInfoView');

				compass.trackPageView('Curtain', {
					src : 'arctic.views.common.hotelInfo',
					meeting_hotel_id : _hotelId,
					meeting_id : _meetingInfo.meeting_id
				});
				
				renderComplete();
			}
		});
	};
	
	function _drawHotelBookingWidget() {
		_hotelBookingWidget = new compass.hotel.HotelBookingWidget(_viewport, {
			WUID : 'crap',
			hotel : _hotel,
			hotelId: _hotelId,
			meetingInfo : _meetingInfo,
			displayHotelStars : _displayHotelStars,
			checkInDate : _arriveDate,
			checkOutDate : _departDate,
			requestedRooms : _occupancy,
			initialBlockedRoomId : _blockedRoomId,
			hideDistance : _hideDistance,
			hideNumberOfRoomsAvailable : _hideNumberOfRoomsAvailable,
			displayPriceSavings: _meetingInfo.displayPriceSavings && _hotel.avail.status === 'NORMAL',
			defaultPromotions : _defaultPromotions,
			categoryHasOnlyOneHotelAvail: _categoryHasOnlyOneHotelAvail
		});

		_hotelBookingWidget.bind("HotelBookingWidget.reserveButtonClicked", _reserveButtonClicked);
		_hotelBookingWidget.bind('HotelBookingWidget.gdsCheckAvail', _gdsCheckAvail);
		_hotelBookingWidget.bind('HotelBookingWidget.recalculateReservationCost', _recalcCost);
		_hotelBookingWidget.bind('HotelBookingWidget.getPolicies', _getPolicies);
		_hotelBookingWidget.bind('HotelBookingWidget.shopOtherHotels', function() {
			_viewport.trigger(CompassEvents.Navigate, 'hotels/1');
		});
	}

	function _reserveButtonClicked(e, resData) {
		var url = '/storeReservation';
		// :FORCED ERRROR: - for greping
		if(window.location.href.indexOf("?throwAnAjaxFailure") > 0 ) {
			url = '/notarealurl';
		}

		resData.category_id = _hotel.category_id;
		resData.meeting_id = _meetingInfo.meeting_id;
		resData.meeting_code = _meetingInfo.meetingCode;

		jQuery.ajax({
			url : url,
			data : JSON.stringify(resData),
			type : 'POST',
			contentType : 'application/json',
			success : function(res) {
				_viewport.trigger(CompassEvents.Navigate, res.route);
			}
		});
	}

	function _getResTrackingData(resData) {
		return {
			iterations : resData.iterations,
			reservations : _.map(resData.reservations, function(r) { 
			    return _.omit(r, 'summary'); })
		};
	}

	function _gdsCheckAvail(e, gdsRequest) {
		var background = d.div({ className : 'curtainBackground' });
		background.css({
			'z-index' : 100000,
			'background-color' : 'rgba(0, 0, 0, 0.8)'
		});
		_viewport.append(background);

		var searchingMsg = d.div({ className : 'searching' }, 'Searching...');
		searchingMsg.css({
			'left' : (background.innerWidth() / 2 - 50) + 'px',
			'top' : (background.innerHeight() / 2 - 10) + 'px'
		});
		background.append(searchingMsg);

		compass.loading.start(background, {
			color : '#FFFFFF',
			lines : 20,
			length : 15,
			width: 7,
			radius : 55,
			trail : 30
		});

		var tryCount = 0;
		var gdsAjax = function () {
			tryCount++;

			if (tryCount > MAX_RETRIES) {
				compass.loading.stop();
				background.remove();
				// TODO: Error handling
				d.alert('There was an issue with the hotel requested.');
				return;
			}
			
			var _url = '/getGDSAvailability';
			
			$j.ajax({
				url : _url,
				timeout : 60000,
				data : {
					hotel_id : gdsRequest.hotel_id,
					arrive : gdsRequest.arrive,
					depart : gdsRequest.depart,
					occupancy : gdsRequest.occupancy,
					rooms : gdsRequest.rooms,
					country_code: gdsRequest.country_code,
					currency: gdsRequest.currency,
					handled_by_our_agent: gdsRequest.handled_by_our_agent
				},
				success : function(res) {
					gdsRequest.callback(res);
					compass.loading.stop();
					background.remove();
				},
				error: gdsAjax
			});
		};

		gdsAjax();
	}

	function _recalcCost(e, resData) {
		jQuery.ajax({
			url : '/reservationCost',
			data : JSON.stringify(resData.values),
			type : 'POST',
			contentType : 'application/json',
			success : function(response) {
				resData.callback(response.stayRecaps, response.chargingInfo);
			}
		});
	}

	function _getPolicies(e, resData) {
		jQuery.ajax({
			url : '/policies',
			data : {
				blocked_room_id : resData.values.blocked_room_id,
				category_id : _hotel.category_id
			},
			success : function(response) {
				resData.callback(response.policies);
			}
		});
	}

	jQuery('.hotelInfoView').bind('HotelInfoWidget.showPolicies', function(event, eventData) {
		if (_hotel.avail.affiliates && _hotel.avail.affiliates[0] === "EAN") {
			jQuery.ajax({
				data: { hotel_id: _hotel.hotelInfo.hotelId },
				dataType:'json',
				traditional: true,
				url:'/getGDSHotelPolicies',
				success : function(data) {

					if (data.gdsHotelPolicies.error) {
						var popupParams = {
							title: 'Sorry, there was a problem',
							message: 'Please click OK to try your request again.',
							triggerName: 'stayOnPage'
						};
						var errorMessage = d.div();
						var textPopupWidget = new compass.arctic.TextPopupWidget(errorMessage, popupParams);
						var textPopupWidgetDialog = d.dialog({
							classes: 'errorDialog',
							contents: errorMessage,
							centerOnView: true,
							showCloseButton: false
						});
						textPopupWidget.bind('stayOnPage', function () {
							textPopupWidgetDialog.close();
						});

					} else {
						var policiesDiv = d.div({className:'policiesContainer'});
						_policiesWidget = new compass.hotel.GDSPoliciesWidget(policiesDiv, {
							WUID: 'GDS_policiesWidget_hotelInfo',
							policies: data,
							affiliateHandledByOurAgent: _meetingInfo.affiliateHandledByOurAgent,
							phone: _meetingInfo.phone
						});

						_policiesDialog = d.dialog({
							classes: 'hotelInfo policiesDialog',
							contents: policiesDiv,
							centerOnView: true
						});
					}
				}
			});
		} else {
			jQuery.ajax({
				data: { blocked_room_id: eventData.blockRoomIds },
				dataType:'json',
				traditional: true,
				url:'/policies',
				success : function(data) {
					var policiesDiv = d.div({className:'policiesContainer'});
					_policiesWidget = new compass.hotel.PoliciesWidget(policiesDiv, {
						WUID : 'policiesWidget_hotelInfo',
						policies: data
					});
	
					_policiesDialog = d.dialog({
						classes: 'hotelInfo policiesDialog',
						contents: policiesDiv,
						centerOnView: true
					});
				}
			});
		}
	});

};

